import { createRouter, createWebHistory } from 'vue-router';
import CheckoutReports from './views/CheckoutReports';
import ExpressCheckoutSingle from './views/ExpressCheckoutSingle';

export const routes = [
    {
        path: '/subscription',
        name: 'Rapporten',
        component: CheckoutReports,
    },
    {
        path: '/eindejaarsactie-2024',
        name: 'EOY2024',
        component: ExpressCheckoutSingle,
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL || ''),
    routes,
});

export default router;
